import React from "react"
import cx from "classnames"
import Link from "gatsby-link"

import { Detail, Image } from "../../elements"
import { formatdate } from "../../../helpers"
import { GraphCms_Interview } from "../../../../graphql-types"

type Props = {
  interview: GraphCms_Interview
  className?: string
  description: Boolean
}

InterviewCard.defaultProps = {
  description: false,
}

function InterviewCard({ interview, className, description }: Props) {
  let createdAt = formatdate(new Date(interview.createdAt))
  let contributor = interview.contributor!

  return (
    <Link to={interview.page!.url!.pathname} className={cx("block", className)}>
      <div className="flex-1 relative">
        <div className="overflow-hidden rounded z-10">
          <Image
            className="block w-full"
            gatsbyImageData={
              interview.page!.image?.localFile?.childImageSharp?.gatsbyImageData
            }
            alt={interview.title}
            zoom
          />
        </div>
        <div className="absolute avatar-gradient rounded-full p-1 w-16 h-16 -bottom-8 left-3">
          <Image
            className="block rounded-full"
            gatsbyImageData={
              interview.contributor?.avatar?.localFile?.childImageSharp
                ?.gatsbyImageData
            }
            alt={interview.contributor?.name || ""}
            width={56}
          />

          <div className="absolute p-1 -right-3 bottom-0 bg-white">
            <Image
              className="block w-full"
              gatsbyImageData={
                interview.contributor?.country?.flag?.localFile?.childImageSharp
                  ?.gatsbyImageData
              }
              alt={interview.contributor?.country?.name || ""}
              width={20}
            />
          </div>
        </div>
      </div>

      <div className="flex-2 py-3">
        <Detail className="text-xs text-gray-dark font-normal mb-3 text-right">
          {createdAt}
        </Detail>

        <Detail className="text-lg font-bold mb-3 leading-5">
          {interview.title}
        </Detail>

        {contributor.occupation && (
          <Detail className="text-base text-gray-dark font-normal">
            {contributor.occupation}
          </Detail>
        )}

        {description && (
          <Detail className="text-base">
            {interview.page?.description ?? ""}
          </Detail>
        )}
      </div>
    </Link>
  )
}

export default InterviewCard
